import { PrimaryButton, Stack } from "@fluentui/react";
import { LockOutlined } from "@mui/icons-material";
import { GridColDef } from "@mui/x-data-grid";
import React from "react";
import { CustomDataGrid } from "../../../../SharedComponents/CustomDataGrid/CustomDataGrid";
import { MSSALES_REQUEST_LINK, NO_DATA_MESSAGE, PERMISSION_MESSAGE } from "../ConsumptionRevenue/ConsumptionRevenueTab.constants";
import { ConsumptionRevenueTabTableProps } from "../ConsumptionRevenue/ConsumptionRevenueTab.interfaces";

const ConsumptionRevenueTabTable = (props: ConsumptionRevenueTabTableProps) => {

  const showRequestLink = () => {
    return (
      <Stack tokens={{ childrenGap: 16 }} horizontalAlign="center">
        <Stack horizontalAlign="center">
          <LockOutlined fontSize="medium" sx={{ color: "black" }} />
          <h4 style={{ margin: 0 }}>{PERMISSION_MESSAGE}</h4>
        </Stack>

        <div>{props.errorMessage}</div>

        <PrimaryButton
          onClick={() => window.open(MSSALES_REQUEST_LINK, "_blank", "noopener,noreferrer")}
          text="Request Access"
        ></PrimaryButton>
      </Stack>
    );
  };

  const showNoData = () => {
    const rootStyle = {
      alignItems: "center",
      display: "flex",
      fontSize: 18,
      fontWeight: 600,
      justifyContent: "center",
      padding: 200
    };
    return <div style={rootStyle}>{props.errorMessage ? showRequestLink() : NO_DATA_MESSAGE}</div>;
  };

  const columns: GridColDef[] = [
    {
      headerName: "Region",
      field: "region",
      width: 150,
      flex: 1
    },
    {
      headerName: "Segment",
      field: "segmentGroup",
      width: 150,
      flex: 1
    },
    {
      headerName: "Sub Segment",
      field: "subSegment",
      width: 200,
      flex: 1
    },
    {
      headerName: "Consumption Revenue",
      type: "number",
      field: "revenue",
      width: 180,
      valueFormatter: (value: number) => value?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
  ];

  React.useEffect(() => {
    setTimeout(() => {
      const elements = document.getElementsByClassName("MuiDataGrid-virtualScroller");
      Array.from(elements).forEach(function (element) {
        element.setAttribute("tabIndex", "0");
      });
    }, 1000);
  }, []);

  return (
    <>
      {props.loading || (props.tableData && props.tableData.length > 0) ? (
        <div style={{ height: 600, width: "100%" }}>
          <CustomDataGrid
            columns={columns}
            enableUrlParams
            exportCsvButtonProps={{
              fileNamePrefix: "consumption-revenue-details"
            }}
            getRowId={(row) => row.id}
            loading={props.loading}
            paginationOptions={{ page: 0, pageSize: 100 }}
            rows={{ values: props.tableData ?? [], count: props.tableData?.length ?? 0 }}
            showCellVerticalBorder
            sx={{
              "& .MuiDataGrid-columnHeaderDraggableContainer": {
                flexDirection: "inherit !important"
              },
              "& .MuiDataGrid-columnHeaderTitleContainer": {
                flexDirection: "inherit !important"
              },
              "& .MuiDataGrid-cell": {
                justifyContent: "flex-start",
                textAlign: "left"
              }
            }}
            kustoLink={props?.kustoLink}
            TabName={`Product View - Consumption Revenue Table for ${props?.productName}`}
          />
        </div>
      ) : (
        showNoData() || ""
      )}
    </>
  );
};

export default ConsumptionRevenueTabTable;
